import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-prescripteurs-item',
  templateUrl: './operation-prescripteurs-item.component.html',
  styleUrls: ['./operation-prescripteurs-item.component.scss']
})
export class OperationPrescripteursItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
